export default "__VITE_ASSET__rqx78BTO__"